import React from 'react';

import classes from './FranchizeTitle.module.scss';

const franchizeTitle = props => <h3 className={classes.Title}>{props.children}</h3>;

export default franchizeTitle;